// Accordion for gifts  
  const gift_accordion = document.getElementById('gift-accordion');
  const what_you_get_list = document.getElementById('what-you-get-list');
  const gifts_list_desktop = document.getElementById('gifts-list-desktop');
  const gifts_list = document.getElementById('gifts-list');
  const icon_plus = document.getElementById('icon-plus');
  const icon_minus = document.getElementById('icon-minus');

  if (gift_accordion) {
    gift_accordion.addEventListener('click', () => {
      const windowWidth = window.innerWidth;

      if (what_you_get_list && windowWidth < 768) {
        const style = window.getComputedStyle(what_you_get_list);
        if (style.display === 'flex') {
          gift_accordion.style.borderBottomWidth = '0.5px';
          gifts_list.style.display = 'none';
          what_you_get_list.style.display = 'none';
          what_you_get_list.style.borderBottom = 'none';     
          icon_plus.style.display = 'block';
          icon_minus.style.display = 'none';
        } else {
          gift_accordion.style.borderBottomWidth = '0';
          gifts_list.style.display = 'block';
          what_you_get_list.style.display = 'flex';
          what_you_get_list.style.borderBottom = '0.5px solid #00000033';
          icon_plus.style.display = 'none';
          icon_minus.style.display = 'block';
        }
      }
    });
  }

  window.addEventListener('resize', () => {
    const windowWidth = window.innerWidth;
    if (windowWidth < 768) {
      gift_accordion.style.borderBottomWidth = '0.5px';
      gifts_list.style.display = 'none';
      what_you_get_list.style.display = 'none';
      what_you_get_list.style.borderBottom = 'none';     
      icon_plus.style.display = 'block';
      icon_minus.style.display = 'none';
    } else {
      gift_accordion.style.borderBottomWidth = '0';
      gifts_list.style.display = !gifts_list_desktop || windowWidth < 1038 ? 'block' : 'none';  
      what_you_get_list.style.display = 'flex';
      what_you_get_list.style.borderBottom = 'none';
      icon_plus.style.display = 'none';
      icon_minus.style.display = 'none';
    }
  });

  // Keen Sliders  
  function navigation(slider) {
    let wrapper, dots
  
    function markup(remove) {
      dotMarkup(remove)
    }
  
    function removeElement(elment) {
      elment.parentNode.removeChild(elment)
    }
  
    function createDiv(className) {
      var div = document.createElement("div")
      var classNames = className.split(" ")
      classNames.forEach((name) => div.classList.add(name))
      return div
    }
  
    function dotMarkup(remove) {
      if (remove) {
        removeElement(dots)
        return
      }
      dots = createDiv("dots")
      slider.track.details.slides.forEach((_e, idx) => {
        var dot = createDiv("dot")
        dot.addEventListener("click", () => slider.moveToIdx(idx))
        dots.appendChild(dot)
      })
      slider.container.parentNode.appendChild(dots)
    }
  
    function updateClasses() {
      var slide = slider.track.details.rel
      Array.from(dots.children).forEach((dot, idx) => {
        idx === slide
          ? dot.classList.add("dot--active")
          : dot.classList.remove("dot--active")
      })
    }
  
    slider.on("created", () => {
      markup()
      updateClasses()
    })
    slider.on("optionsChanged", () => {
      markup(true)
      markup()
      updateClasses()
    })
    slider.on("slideChanged", () => {
      updateClasses()
    })
    slider.on("destroyed", () => {
      markup(true)
    })
  }
  
  const slider = new KeenSlider('#keen_large_slider', {}, [navigation]);
  const slider2 = new KeenSlider('#keen_large_slider2', {}, [navigation]);

  // Swith Sliders  
  const product_images = document.getElementById('product-images');
  const before_after_images = document.getElementById('before-after-images');
  const slider_box = document.getElementById('keen_large_slider');
  const slider2_box = document.getElementById('keen_large_slider2');
  const dots = document.querySelectorAll('.dots');

  slider2_box.classList.add('hidden-slider');
  slider_box.classList.add('active-slider');
  dots[1].style.display = 'none';

  if (product_images) {
    product_images.addEventListener('click', () => {
      slider2_box.classList.remove('active-slider');
      slider2_box.classList.add('hidden-slider');
      dots[1].style.display = 'none';

      slider_box.classList.remove('hidden-slider');
      slider_box.classList.add('active-slider');
      dots[0].style.display = 'flex';

      before_after_images.classList.remove('bg-[#E6CFB7]');
      before_after_images.classList.add('bg-[#FFFFFF]');  

      product_images.classList.remove('bg-[#FFFFFF]');
      product_images.classList.add('bg-[#E6CFB7]');      
    });
  }

  if (before_after_images) {
    before_after_images.addEventListener('click', () => {
      slider_box.classList.remove('active-slider');
      slider_box.classList.add('hidden-slider');
      dots[0].style.display = 'none';

      slider2_box.classList.add('hidden-slider');
      slider2_box.classList.add('active-slider');
      dots[1].style.display = 'flex';

      product_images.classList.remove('bg-[#E6CFB7]');
      product_images.classList.add('bg-[#FFFFFF]');

      before_after_images.classList.remove('bg-[#FFFFFF]');
      before_after_images.classList.add('bg-[#E6CFB7]');  
    });
  } 
